module.exports = __webpack_public_path__ + "static/media/clark.cf1fbc40.png";